export enum Routes {
  INSIGHTS_BASE = '/insights',
  OLIO_ENGAGEMENT_SCORE = 'olio-engagement-score',
  AVERAGE_LENGTH_OF_STAY = 'average-length-of-stay',
  READMISSION_RATE = 'readmission-rate',
  TOTAL_DISCHARGES = 'total-discharges',
  PRIORITIES_NOTE_RESPONSE = 'priorities',
  ESCALATIONS_RESPONSE = 'escalations',
  ACTIVITIES_PER_PATIENT_PER_WEEK = 'activities-per-patient-per-week',
}

export enum Metrics {
  ACTIVITIES_PER_PATIENT_PER_WEEK = 'activities_per_patient_per_week',
  LENGTH_OF_STAY_AVERAGE = 'length_of_stay:average',
  BUSINESS_RESPONSE_TIME_AVERAGE = 'business_response_time:average',
  ID_COUNT = 'id:count',
  LENGTH_OF_STAY_SUM = 'length_of_stay:sum',
  LOCATION_EPISODE_ID_COUNT = 'location_episode_id:count',
  OLIO_ENGAGEMENT_SCORE = 'olio_engagement_score',
  OWNER_ACTIVITIES_COUNT = 'owner_activities:count',
  OWNER_ACTIVITIES_SUM = 'owner_activities:sum',
  READMISSION_RATE = 'readmission_rate',
  READMISSIONS_SUM = 'readmissions:sum',
  RESPONSE_TIME_AVERAGE = 'response_time:average',
}

export enum Dimensions {
  DATE = 'date',
  EPISODE_URL = 'episode_url',
  GROUP_NAME = 'group_name',
  GROUP = 'group',
  LENGTH_OF_STAY = 'length_of_stay',
  OWNER_GROUP_NAME = 'owner_group_name',
  OWNER_GROUP_ID = 'owner_group_id',
  PATIENT_NAME = 'patient_name',
  PROVIDER_NAME = 'provider_name',
  PROVIDER_ID = 'provider_id',
  PLAN_TYPE_CLASSIFICATION = 'plan_type_classification',
  PLAN_TYPE_CLASSIFICATION_ID = 'plan_type_classification_id',
  REASON = 'reason',
  REASON_ID = 'reason_id',
  EPISODE_CLASSIFICATION = 'episode_classification',
  EPISODE_CLASSIFICATION_ID = 'episode_classification_id',
  OWNER_CLIENT = 'owner_client',
  PROVIDER_CLIENT = 'provider_client',
  PROVIDER_CLIENT_ID = 'provider_client_id',
  READMISSION_DATE = 'readmission_date',
}

export enum Sources {
  LOCATION_EPISODE_DAYS = 'location_episode_days',
  LOCATION_EPISODE_DISCHARGES = 'location_episode_discharges',
  ESCALATION_ACKS = 'escalation_acks',
}

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}
